import { Route } from '@angular/router';
import { StandByComponent } from './components/stand-by/stand-by.component';

export const ROUTES: Route[] = [
  {
    path: '',
    component: StandByComponent,
  },
];

export const STAND_BY_ROUTES = async () => ROUTES;
